import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/layout/AppShell";
import { LayoutTemplate, Layers, HelpCircle, CheckCircle2, Settings2 } from "lucide-react";

export default function Templates() {
  const [templates, setTemplates] = useState(null);
  const { user } = useAuth();
  const navigate = useNavigate();
  useEffect(() => { api.get("/templates").then((r) => setTemplates(r.data)); }, []);
  const canEdit = user?.role === "admin";

  return (
    <>
      <PageHeader title="Discovery Templates" subtitle="Reusable, configurable discovery journeys. Adding more products later needs no redesign." />
      <div className="flex-1 px-6 py-8 lg:px-10">
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
          {templates?.map((t) => (
            <div key={t.id} data-testid={`template-card-${t.id}`} className="rounded-2xl border border-slate-200 bg-white p-6 transition-all duration-200 hover:shadow-md">
              <div className="flex items-start gap-4">
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-sky-50"><LayoutTemplate className="h-6 w-6 text-sky-600" /></div>
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <h3 className="font-heading text-lg font-bold text-slate-900">{t.name}</h3>
                    <span className="rounded-full bg-emerald-50 px-2 py-0.5 text-[11px] font-bold text-emerald-600 flex items-center gap-1"><CheckCircle2 className="h-3 w-3" /> Active</span>
                  </div>
                  <p className="mt-1 text-sm text-slate-500">{t.description}</p>
                  <div className="mt-4 flex gap-4 text-sm">
                    <span className="flex items-center gap-1.5 font-semibold text-slate-600"><Layers className="h-4 w-4 text-slate-400" /> {t.module_count} modules</span>
                    <span className="flex items-center gap-1.5 font-semibold text-slate-600"><HelpCircle className="h-4 w-4 text-slate-400" /> {t.question_count} questions</span>
                  </div>
                  {canEdit && (
                    <button data-testid={`manage-template-${t.id}`} onClick={() => navigate("/administration")}
                      className="mt-4 inline-flex items-center gap-1.5 rounded-lg bg-sky-50 px-3 py-2 text-sm font-semibold text-sky-700 transition-colors hover:bg-sky-100">
                      <Settings2 className="h-4 w-4" /> Manage modules & questions
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8">
          <h3 className="mb-3 font-heading text-sm font-bold uppercase tracking-wider text-slate-400">Coming soon</h3>
          <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4">
            {["Service Cloud Core", "Experience Cloud", "Field Service", "Revenue Cloud", "Data Cloud", "Agentforce"].map((n) => (
              <div key={n} className="rounded-xl border border-dashed border-slate-300 bg-slate-50/50 p-5 text-center">
                <div className="font-heading text-sm font-bold text-slate-500">{n}</div>
                <div className="mt-1 text-[11px] font-semibold uppercase tracking-wide text-slate-400">Coming Soon</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
